import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    createUrl: String,
    redirectUrl: String,
    widgetId: String,
  };

  static targets = ['loader'];

  connect() {
    this.fetchOnboardingUrl();
  }

  async fetchOnboardingUrl() {
    let response;

    try {
      response = await fetch(this.createUrlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json',
        },
      });
    } catch (error) {
      console.error('Failed to fetch onboarding URL:', error);
      return;
    }

    if (response.status === 409) {
      const data = await response.json();
      window.location.replace(data.redirect_url);
      return;
    }

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (_error) {
        return;
      }
      if (errorData.duplicate_account) {
        window.location.replace(errorData.redirect_url);
      }
      return;
    }

    let onboarding_url; // eslint-disable-line camelcase

    try {
      ({ onboarding_url } = await response.json()); // eslint-disable-line camelcase
    } catch (error) {
      console.error('Failed to parse onboarding response:', error);
      return;
    }

    this.loaderTarget.classList.add('d-none');
    this.initWidget(onboarding_url);
  }

  initWidget(onboardingUrl) {
    LemonwayWidget.init(
      onboardingUrl,
      this.widgetIdValue,
      {
        lang: 'fr',
        onMyAccount: () => this.redirectToNextStep(false),
        onFinish: () => this.redirectToNextStep(true),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: 'smooth',
        }),
      }
    );
  }

  redirectToNextStep(success = false) {
    const url = new URL(this.redirectUrlValue);

    if (success) {
      url.searchParams.set('status', 'success');
    }

    window.location.replace(url);
  }
}
